import React from 'react'
import { ActionsMenu } from '@opallabs/lapidary'
import { ActionRenderer } from './ActionRenderer'
import { buildActions } from './buildActions'
import type { ContentCardOptionsMenuProps } from './types'

export const ContentCardOptionsMenu: React.FC<ContentCardOptionsMenuProps> = (
  props
) => {
  const { legacyTheme } = props
  const actions = buildActions(props)

  return (
    <ActionsMenu.Base
      className="lapidary-content-card-options-menu"
      glyph="gem-more-horizontal"
      glyphColor="Secondary"
      align="start"
      themeFromBackbone={legacyTheme}
      tooltipContent="More Options"
      variant="ghost"
      zIndex={9999}
    >
      {actions.map((action, i) => {
        // Avoid rendering separators that have no actions following
        if (action.type === 'separator' && i === actions.length - 1) {
          return null
        }

        return (
          <ActionRenderer
            key={
              action.type === 'separator' ? `separator-${i}` : action.actionType
            }
            action={action}
            parentProps={props}
          />
        )
      })}
    </ActionsMenu.Base>
  )
}
